import { render, staticRenderFns } from "./CisternIndex.vue?vue&type=template&id=6046871c&scoped=true&"
import script from "./CisternIndex.vue?vue&type=script&lang=js&"
export * from "./CisternIndex.vue?vue&type=script&lang=js&"
import style0 from "./CisternIndex.vue?vue&type=style&index=0&id=6046871c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6046871c",
  null
  
)

export default component.exports